import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAppSelector } from "@/redux/hooks";
import { loginSignupSelector } from "@/components/login-signup/LoginSignupSlice";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute component - protects private routes
 * Case 2: After logout, users cannot access private URLs even via browser history
 * Case 4: Private URLs are always protected until user logs in successfully
 */
export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { authenticated, token } = useAppSelector(loginSignupSelector);
  const location = useLocation();

  // Check authentication on every render/navigation
  // This ensures browser history cannot be used to access private routes after logout
  useEffect(() => {
    // Force re-check on location change
    if (!authenticated || !token) {
      // Clear any stale data from localStorage
      localStorage.removeItem("persist:root");
    }
  }, [authenticated, token, location.pathname]);

  if (!authenticated || !token) {
    // Use replace: true to prevent browser history access
    // This ensures users cannot go back to private routes after logout
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};

